/*
dilip  10/11/2022  3075154998  Data Manager Matching logic changes
Akhila  10/28/2022 3075154998 data manager ux changes

 */
import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddDataManagerFilter from './AddDataManagerFilter/index';
import SearchDataManagerFilter from './SearchDataManagerFilter/index';

const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'padding': {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
  'searchRuleButton': {
    margin: '-8px 0 8px',
  },
}));

export default function DmFilterTabs() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [valueCode, setValueCode] = useState(0);
  const [filterCode, setFilterCode] = useState(null);
  const [filterCodeName, setFilterCodeName] = useState('');
  const [isCopyRowData, setIsCopyRowData] = useState(false);
  const [fieldRowData, setFieldRowData] = useState('');
  return (
    <div className={classes.root}>
      <div className={classes.searchRuleButton}>
        {/* <AntTabs
          className={classes.demo1}
          value={value}
          onChange={handleChange}
          aria-label="ant example"
          variant="scrollable"
          scrollButtons="auto"
        >
          <AntTab label="Search Filter" />
          <AntTab label="Add Filter" />
          <AntTab label="Add Filter Group" />
        </AntTabs> */}
        <Typography />
      </div>
      <div className={classes.subContent}>
        {value === 0 && (
          <SearchDataManagerFilter
            setTabValue={setValue}
            setValueCode={setValueCode}
            value={value}
            setFilterCode={setFilterCode}
            setFilterCodeName={setFilterCodeName}
            setIsCopyRowData={setIsCopyRowData}
            fieldRowData={fieldRowData}
            setFieldRowData={setFieldRowData}
          />
        )}
        {value === 1 && (
          <AddDataManagerFilter
            setTabValue={setValue}
            setValueCode={setValueCode}
            valueCode={valueCode}
            filterCode={filterCode}
            setFilterCode={setFilterCode}
            filterCodeName={filterCodeName}
            setFilterCodeName={setFilterCodeName}
            isCopyRowData={isCopyRowData}
          />
        )}
        {/* {value === 1 && (
          <AddFilterGroup
            setValue={setValue}
          />
        )}
         {value === 2 && (
          <AddFilterGroup
            setValue={setValue}
          />
        )} */}
      </div>
    </div>
  );
}
